export default __webpack_public_path__ + "static/media/cumulus.4be98115.png";